// Acesso ao portal do cliente e visões de cada pessoa (BBF-179, decisão D2 de 18/10/2026): só a
// equipe Busifarm concede. O identity guarda isso fora do PUT do usuário, numa rota própria
// (`PUT /auth/users/{id}/portal`), e as leituras trazem `acessoPortal` e `visoesPortal`.

/** Visões do portal, na ordem da tela. A chave é o contrato com o identity (`VisaoDoPortal`). */
export const VISOES_DO_PORTAL = [
    {value: 'FINANCEIRA', label: 'Financeira', description: 'Faturas, boletos e Pix.'},
    {value: 'LICENCAS', label: 'Licenças'},
    {value: 'SUPORTE', label: 'Suporte'},
    {value: 'USUARIOS_E_PERFIS', label: 'Usuários e perfis'},
];

const ORDEM_DAS_VISOES = VISOES_DO_PORTAL.map((visao) => visao.value);

export const MENSAGEM_SEM_VISAO = 'Escolha ao menos uma visão do portal para liberar o acesso.';

/** Rótulo da visão; uma chave que a tela não conhece aparece como veio. */
export const rotuloDaVisao = (visao) => VISOES_DO_PORTAL.find((item) => item.value === visao)?.label || visao;

/** Só as visões conhecidas, sem repetição e na ordem da tela. */
export const visoesConhecidas = (visoes) => {
    const escolhidas = new Set(Array.isArray(visoes) ? visoes : []);
    return ORDEM_DAS_VISOES.filter((visao) => escolhidas.has(visao));
};

/** Portal da conta como a leitura do identity o traz. Sem o acesso, nenhuma visão vale. */
export const portalDaConta = (conta) => {
    const acesso = conta?.acessoPortal === true;
    return {acesso, visoes: acesso ? visoesConhecidas(conta?.visoesPortal) : []};
};

/** Erro de validação do portal, ou vazio. Com o acesso ligado, ao menos uma visão. */
export const validarPortal = (portal) => (
    portal?.acesso && visoesConhecidas(portal?.visoes).length === 0 ? MENSAGEM_SEM_VISAO : ''
);

/**
 * Corpo do `PUT /auth/users/{id}/portal`. Sem o acesso, as visões vão vazias: o identity as tira
 * de qualquer jeito, e o rascunho da tela pode guardá-las para quem religar o acesso.
 */
export const portalParaPayload = (portal) => {
    const acesso = Boolean(portal?.acesso);
    return {acesso, visoes: acesso ? visoesConhecidas(portal?.visoes) : []};
};

/** Se dois portais valem o mesmo (visões fora de ordem ou guardadas sem o acesso não contam). */
export const mesmoPortal = (a, b) => (
    JSON.stringify(portalParaPayload(a)) === JSON.stringify(portalParaPayload(b))
);

/** Texto curto da lista: nenhuma, todas ou os nomes das visões. */
export const resumoDasVisoes = (visoes) => {
    const conhecidas = visoesConhecidas(visoes);
    if (!conhecidas.length) return 'Nenhuma visão';
    if (conhecidas.length === ORDEM_DAS_VISOES.length) return 'Todas as visões';
    return conhecidas.map(rotuloDaVisao).join(' · ');
};
